// extracted by mini-css-extract-plugin
export default {"container":"Feature_container__VaS4g","title":"Feature_title__UNwpF","subTitle":"Feature_subTitle__1sddf"};